export var OnboardingStatus;
(function (OnboardingStatus) {
    OnboardingStatus["EMAIL_SUBMITTED"] = "EMAIL_SUBMITTED";
    OnboardingStatus["FORM_IN_PROGRESS"] = "FORM_IN_PROGRESS";
    OnboardingStatus["COMPLETED"] = "COMPLETED";
    OnboardingStatus["WAITLISTED"] = "WAITLISTED"; // Non-OSU student, waiting for campus expansion
})(OnboardingStatus || (OnboardingStatus = {}));
